module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#user",
      toString: function () {
        return this.url;
      }
    }